import React from 'react';
import Article from 'features/Articles/Article';
import { forTerminal } from 'utils/platforms';

const ArticleScene = ({ match }) => {
    const articleIds = {
        link: match.params.link,
        productId: match.params.productId,
    };

    const styles = {
        Card: forTerminal({
            marginTop: '-10px',
        }),
    };

    return <Article articleIds={articleIds} styles={styles} />;
};

export default ArticleScene;
